import React, { Component } from 'react';
import { ADMIN_SESSIONS, ADMIN_GAMES, ADMIN_USERS } from '../../routes';
import sortBy from 'lodash/sortBy';
import last from 'lodash/last';
import moment from 'moment';
import './styles.scss';
import AdminNavigationItem from './AdminNavigationItem';

class AdminNavigation extends Component {
	constructor(props) {
		super(props);

		this.state = {
			items: [
				{
					theme: 'orange',
					to: ADMIN_SESSIONS,
					icon: 'sessions',
					title: 'SESSIONS',
					counter: 1,
					note: 'Number of times the simulation was used in class',
					lastTracked: {
						label: 'Last session',
						name: 'Prova Giulia',
						team: 'Team blu',
						date: '12-08-2018'
					}
				},
				{
					theme: 'blue',
					to: ADMIN_GAMES,
					icon: 'games',
					title: 'GAMES',
					counter: 2,
					note:
						'Number of single players who played the simulation in different sessions',
					lastTracked: null
				},
				{
					theme: 'salmon',
					to: ADMIN_USERS,
					icon: 'users',
					title: 'USERS',
					counter: 32,
					note:
						'Number of users involved in all the sessions that pertain to you (players, admins or instructors)',
					lastTracked: null
				}
			]
		};
	}

	componentDidMount() {
		// Simulate call to GraphQL
		// Fake Data in "const results" above Component class declaration!
		// this.setState({
		// 	games: this.props.games,
		// 	sessions: this.props.sessions,
		// 	users: this.props.users
		// })
	}

	getItems() {
		const { games, sessions, users } = this.props;
		const lastSession = last(sortBy(sessions, ['createdAtRaw']));
		return [
			{
				theme: 'orange',
				to: ADMIN_SESSIONS,
				icon: 'sessions',
				title: 'SESSIONS',
				counter: sessions.length,
				note: 'Number of times the simulation was used in class',
				lastTracked: {
					label: lastSession ? 'Last Session' : '',
					name: lastSession ? lastSession.name : '',
					team: '',
					date: lastSession
						? moment(parseInt(lastSession.createdAtRaw)).format('D MMMM YYYY')
						: ''
				}
			},
			{
				theme: 'blue',
				to: ADMIN_GAMES,
				icon: 'games',
				title: 'GAMES',
				counter: games,
				note:
					'Number of single players who played the simulation in different sessions',
				lastTracked: null
			},
			{
				theme: 'salmon',
				to: ADMIN_USERS,
				icon: 'users',
				title: 'USERS',
				counter: users.length,
				note:
					'Number of users involved in all the sessions that pertain to you (players, admins or instructors)',
				lastTracked: null
			}
		];
	}

	deleteSession() {
		// deleteSession, { data }
		// const id = data.user.sessions[ data.user.sessions.length - 1 ];
		// const returned = deleteSession(id).then();
		// console.log(returned);
		// debugger;
	}

	render() {
		const { title } = this.props;
		const items = this.getItems();
		const itemsTpl = items.map((item, index) => {
			return (
				<AdminNavigationItem
					key={index}
					theme={item.theme}
					icon={item.icon}
					to={item.to}
					title={item.title}
					counter={item.counter}
					note={item.note}
					lastTracked={item.lastTracked}
				/>
			);
		});

		return (
			<div className="AdminNavigation">
				{title && <h2 className="AdminNavigation-title">{title}</h2>}
				<div className="AdminNavigation-content">{itemsTpl}</div>
			</div>
		);
	}
}

export default AdminNavigation;
